
import { FileDetails } from '@/interfaces/files';
import { MutationTree } from 'vuex';


const mutation: MutationTree<FileDetails> = {

    setFileId(state, fileId) {
        state.fileId = fileId;
    },
    setNombre(state, nombre) {
        state.nombre = nombre;
    },
    setClasificacion(state, clasificacion) {
        state.clasificacion = clasificacion;
    },
    setResultado(state, resultado) {
        state.resultado = resultado;
    },
    setRevision(state, revision) {
        state.revision = revision;
    },
    setLC(state, LC) {
        state.LC = LC;
    },
    setEstado(state, estado) {
        state.estado = estado;
    },
    setRevisado(state, revisado) {
        state.revisado = revisado;
    },
    setTxt(state, txt) {
        state.txt = txt;
    },
    setDeletedFile(state, deletedFile) {
        state.deletedFile = deletedFile;
    },
    setReload(state, reload) {
        state.reload = reload;
    },
    setDocuments(state, documents) {
        state.documents = documents;
    },
    setReloadFileList(state, boolean){
        state.reloadFileList = boolean;
    },
    setMovingFile(state, movingFile){
        state.movingFile = movingFile;
    },
    setStartTime(state, startTime){
        state.startTime = startTime;
    },
    setDetectedErrors(state, detectedErrors){
        state.detectedErrors = detectedErrors;
    },
    setPaginationData(state, paginationData){
        state.paginationData = paginationData;
    },
    
}


export default mutation;